import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import GettingStarted from '@segment/templates/GettingStarted'
import NavigationV2 from '@segment/templates/Navigation2'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import PlansCards from './components/PlansCards'
import LogoCarousel from './components/LogoCarousel'
import WhichPlan from './components/WhichPlan'
import ComparePlans from './components/ComparePlans'
import Faq from './components/Faq'

const Pricing = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Segment Pricing Options | Twilio Segment"
        pageDescription="Twilio Segment offers plans and pricing for any budget. Find a pricing plan which fits your needs best."
        themeColor={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <PlansCards />
          <LogoCarousel />
          <WhichPlan />
          <ComparePlans />
          <Faq />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default Pricing
